import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { DepartmentService } from '../../services/jrni/department.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { BasketService } from '../../services/jrni/basket.service';
import { MemberService } from '../../services/jrni/member.service';
import {
	UntypedFormGroup,
	UntypedFormBuilder,
	Validators,
	UntypedFormControl,
  FormGroup,
	FormControl,
} from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from '../../services/datastore.service';
import { AppConfig } from '../../app.config';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { AlertService } from '../../_alert';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../services/jrni/api.service';
import moment from 'moment-timezone';
import { QuestionsService } from '../../services/questions.service';
import { CapitaService } from '../../services/capita.service';
import * as generator from 'generate-password-browser';
import { ConfigService } from '../../services/config.service';
import { BehaviorSubject, map } from 'rxjs';
import { Meta, MetaDefinition } from '@angular/platform-browser';
import { B2cService } from '../../services/b2c.service';
import { ExtendedJwtPayload } from '../../models/ExtendedJwtPayload.model';
import { schema } from '@angular-devkit/core';

@Component({
	selector: 'app-summary',
	templateUrl: './summary.component.html',
	styleUrls: ['./summary.component.scss'],
})
export class SummaryComponent implements OnInit, OnDestroy {
	costBreakDown;
	selectedDepartment;
	selectedLocation;
	selectedService;
	pageTitle: string;
	summaryPageText: string;
	selectedSlot;
	selectedResource;
	selectedResourceObj;
	endSlot;
	termsAndConditions;
	submitted = false;
	items;
	member;
	client;
	address;
	lat;
	long;
	bookingQuestions = [];
	bookingAnswers = [];
	displayTnCs: boolean;
	bookingSummaryData = [];
	companySummaryData = [];
	total = 0;
	extraDetailsPresent = false;
	slotAvailable = true;
	dateOfBirth = '';
	checkoutStarted = false;
	checkoutFailed = false;
	// Last-resort timer: if we are still "Processing" long after Continue, something
	// between spinner.show() and the gateway redirect died without saying so.
	private checkoutWatchdog: any = null;
	adminJourney = false;
	adminForm: UntypedFormGroup;
	adminFormSubmitted = false;
	confirmContinue = false;
	pageName: any;
	communityVenue = false;
	config: any;
	store: BehaviorSubject<any>;
	addedItem: BehaviorSubject<any>;
	ceremonyFee: any;
	dataPolicy: string;
	servicePolicy: string;
	tncPolicy: string;
	tokenData: ExtendedJwtPayload;
	tokenValid: boolean;
	customerQuestions;
	dateId;
	agentMode: any;
	// Initialise the customer form
	customerDetailsForm: UntypedFormGroup = new UntypedFormGroup({
		first_name: new UntypedFormControl('', Validators.required),
		last_name: new UntypedFormControl('', Validators.required),
		email_address: new UntypedFormControl('', [
			Validators.required,
			Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/i),
		]),
		email_address_consent: new UntypedFormControl('', Validators.requiredTrue),
		contact_number: new UntypedFormControl('', [
			Validators.required,
			Validators.minLength(5),
			Validators.maxLength(11),
			Validators.pattern(/[0-9]/),
		]),
		contact_number_consent: new UntypedFormControl('', Validators.requiredTrue),
		// postcode: new FormControl(""),
		// selectedAddress: new FormControl(""),
		dob_day: new UntypedFormControl(false, [
			Validators.required,
			Validators.min(1),
			Validators.max(31),
		]),
		dob_month: new UntypedFormControl(false, [
			Validators.required,
			Validators.min(1),
			Validators.max(12),
		]),
		dob_year: new UntypedFormControl(false, Validators.required),
		password: new UntypedFormControl(''),
		copyData: new UntypedFormControl('No'),
		// confirm_password: new FormControl('', [Validators.required, confirmPasswordValidator]),
	});
	loggedIn = false;

	breadcrumbItems = [
		{ text: 'Home', href: '/start' },
		{ text: 'Ceremony Selection', href: '/services' },
		{ text: 'Date & Time', href: '/calendar' },
		{ text: 'Booking Details', href: '/booking-details' },
		{ text: 'Summary', href: '/summary' },
	];

	policyForm = new UntypedFormGroup({
		tnc: new UntypedFormControl('', [Validators.requiredTrue]),
		// servicePolicy: new UntypedFormControl('', [Validators.requiredTrue]),
		dataPolicyBox: new UntypedFormControl('', [Validators.requiredTrue]),
		paymentInfo: new UntypedFormControl('', [Validators.requiredTrue]),
	});

  meta = inject(Meta);
	constructor(
		private router: Router,
		private departmentService: DepartmentService,
		private servicesService: ServicesService,
		private availabilityService: AvailabilityService,
		private basketService: BasketService,
		private memberService: MemberService,
		private formBuilder: UntypedFormBuilder,
		private spinner: NgxSpinnerService,
		public datastoreService: DatastoreService,
		private alertService: AlertService,
		public translateService: TranslateService,
		private apiService: ApiService,
		private questionsService: QuestionsService,
		private configService: ConfigService,
		private b2cService: B2cService,
    private capitaService: CapitaService
	) { }

	checkPolicy(policy: any) {
		if (this.policyForm.valid) {
			this.confirmContinue = true;
		} else {
			this.confirmContinue = false;
		}
	}

	routerGoBack() {
		this.router.navigate(['/booking-details']);
	}

	restartJourney() {
		this.router.navigate(['']);
	}

	get form() {
		return this.adminForm.controls;
	}

	async ngOnInit() {
		this.store = new BehaviorSubject(false);
		this.addedItem = new BehaviorSubject(false);
		this.pageName = this.router.url;
		this.scrollToTop();
		this.alertService.clear();
		this.config = await this.configService.getConfig();
		this.agentMode = localStorage.getItem('agent');

		this.policyForm.valueChanges.subscribe((values) => this.checkPolicy(values));


		if (this.datastoreService.adminJourney) {
			this.adminJourney = true;
			this.costBreakDown = this.datastoreService.costBreakDown;
			this.loggedIn = true; // force this to true on admin journey in order to show the form
		}
		this.servicesService.get().then(async (company) => {
			if (company === undefined) {
				// company not found, restart
				this.restartJourney();
			} else {
				if (this.b2cService.token && !this.adminJourney) {
					// verify token
					const decodedToken = this.b2cService.decodedToken;
					this.tokenData = decodedToken;
					this.tokenValid = this.b2cService.isTokenExpired();
					if (!this.b2cService.isTokenExpired()) {
						this.loggedIn = true;
						this.departmentService.getCustomerQuestions().then((questions) => {
							const filteredQuestions = [];
							for (let index = 0; index < questions.length; index++) {
								const question = this.customerQuestions[index];
								filteredQuestions.push(question);
								question.visible = false;
								question.reference = question.id;
								if (!question.admin_only) {
									if (
										!question.settings.hasOwnProperty('conditional_question')
									) {
										question.visible = true;
									}

									const questionControl = question.id;
									if (
										question.detail_type == 'check' ||
										question.detail_type == 'check-price'
									) {
										if (question.default == 1) {
											if (question.required) {
												this.customerDetailsForm.addControl(
													questionControl,
													new UntypedFormControl(true, Validators.requiredTrue)
												);
											} else {
												this.customerDetailsForm.addControl(
													questionControl,
													new UntypedFormControl(true)
												);
											}
										} else {
											if (question.required) {
												this.customerDetailsForm.addControl(
													questionControl,
													new UntypedFormControl('', Validators.requiredTrue)
												);
											} else {
												this.customerDetailsForm.addControl(
													questionControl,
													new UntypedFormControl(false)
												);
											}
										}
									} else {
										// Need to add the control for display purposes but we don't need to validate it as we've added three new controls.
										if (
											question.id !== 1 &&
											question.id !== 279 &&
											question.id !== 34
										) {
											if (question.required) {
												this.customerDetailsForm.addControl(
													questionControl,
													new UntypedFormControl('', Validators.required)
												);
											} else {
												this.customerDetailsForm.addControl(
													questionControl,
													new UntypedFormControl('')
												);
											}
										} else {
											this.customerDetailsForm.addControl(
												questionControl,
												new UntypedFormControl('')
											);
										}
									}
								}
								// }
							}
							this.customerQuestions = filteredQuestions;
							this.datastoreService.customerQuestions = filteredQuestions;
							this.dateId = '';
							// id of date question is one of these, but we don't know which
							if (this.customerDetailsForm.get('1') !== undefined)
								this.dateId = '1';
							if (this.customerDetailsForm.get('279') !== undefined)
								this.dateId = '279';
							if (this.customerDetailsForm.get('34') !== undefined)
								this.dateId = '34';
						});
						this.datastoreService.customerDetailsForm = this.customerDetailsForm;
						this.customerDetailsForm.get('first_name').setValue(this.tokenData.given_name);
						this.customerDetailsForm.get('last_name').setValue(this.tokenData.family_name);
						this.customerDetailsForm.get('email_address').setValue(this.tokenData.emails[0]);
						// now we have to actually verify the integrity of the token
            console.log(this.datastoreService.companyAnswers);
            if (this.datastoreService.companyAnswers.controls['28'].value) {
              this.customerDetailsForm.get('contact_number').setValue(this.datastoreService.companyAnswers.controls['28'].value);
            }

					}
					else {
						console.error(`Token expired at ${this.b2cService.getExpiry()}`);
						this.spinner.hide();
						this.alertService.error(
							// this.translateService.instant('COMMON.GENERAL_ERR')
							`Unable to log you in.`
						);
					}
				}
				else {
					if (this.adminJourney) {
						this.customerDetailsForm = this.datastoreService.customerDetailsForm;
					}
				}
        this.loggedIn = true;
				if (this.loggedIn) {
					// Set the questions and answer
					this.bookingQuestions = this.datastoreService.bookingQuestions;
					this.client = this.datastoreService.customerDetailsForm.getRawValue();

					// Get the selected location
					// Use this.departmentService.getLocation() if the services are set on the children departments
					// Use this.departmentService.get() if the services are set on the parent department
					this.departmentService.getLocation().then((location) => {
						this.selectedLocation = location;
						console.log(this.selectedDepartment);
						this.address = location.address;
						this.datastoreService.address = location.address;
					});
					this.availabilityService.getSelectedResource().then((resource) => {
						if (resource) {
							this.selectedResource = resource;
						}
					});
					this.availabilityService.getSelectedResourceObj().then((resource) => {
						if (resource) {
							this.selectedResourceObj = resource;
						}
					});
					// Get the selected slot
					if (this.datastoreService.selectedSlot) {
						this.availabilityService.getSelectedSlot().then((slot) => {
							this.selectedSlot = slot;
							this.availabilityService.getEndSlot().then((slot) => {
								this.endSlot = slot;
							});
						});
					}

					// don't know exactly what the id of the date question is
					if (
						this.datastoreService.customerDetailsForm.controls['1'] !== undefined
					)
						this.dateOfBirth = this.getDOB(
							this.datastoreService.customerDetailsForm.controls['1'].value
						);
					if (
						this.datastoreService.customerDetailsForm.controls['279'] !==
						undefined
					)
						this.dateOfBirth = this.getDOB(
							this.datastoreService.customerDetailsForm.controls['279'].value
						);
					if (
						this.datastoreService.customerDetailsForm.controls['34'] !== undefined
					)
						this.dateOfBirth = this.getDOB(
							this.datastoreService.customerDetailsForm.controls['34'].value
						);

					// Use this.departmentService.getLocation() if the services are set on the children departments
					// Use this.departmentService.get() if the services are set on the parent department
					this.departmentService.get().then((selectedDepartment) => {
						if (selectedDepartment === undefined) {
							this.restartJourney();
						} else {
							console.log('selected dept', selectedDepartment);
							this.selectedDepartment = selectedDepartment;

							// Get the configurable data
							if (this.selectedDepartment.hasOwnProperty('extra')) {
								// Set the title on the login page to the title from the business question
								this.selectedDepartment.extra.hasOwnProperty('review_page_title')
									? (this.pageTitle =
										this.selectedDepartment.extra.review_page_title)
									: (this.pageTitle = 'Review title not set');
								// Set the extra text on the page to the text taken from the business question
								this.selectedDepartment.extra.hasOwnProperty('summary_page_text')
									? (this.summaryPageText =
										this.selectedDepartment.extra.summary_page_text)
									: null;
								// Tncs
								this.getTermsAndConditions();
							}

							// Use this.departmentService.getLocation() if the services are set on the children departments
							// Use this.departmentService.get() if the services are set on the parent department
							this.departmentService.getLocation().then((location) => {
								this.selectedLocation = location;
							});

							// Get the selected service
							this.servicesService.get().then((service) => {
								this.selectedService = service;
								if (
									this.config.community_venues.includes(this.selectedService.id)
								) {
									this.communityVenue = true;
									console.log('Community venue');
								}

								this.selectedService.calculated_duration =
									Number(this.datastoreService.extraDuration) +
									Number(this.selectedService.durations[0]);

								this.datastoreService.bookingQuestions.forEach((question) => {
									if (this.datastoreService.bookingForm.value[question['id']]) {
										this.bookingSummaryData.push({
											name: question.name,
											answer:
												this.datastoreService.bookingForm.value[question.id],
											detail_type: question.detail_type,
											price: question.price,
											reference: question.conditionals.question_reference ? question.conditionals.question_reference : ""
										});
									} else if (
										this.datastoreService.companyQuestionsForm.value[
										question['id']
										]
									) {
										this.bookingSummaryData.push({
											name: question.name,
											answer:
												this.datastoreService.companyQuestionsForm.value[
												question.id
												],
											detail_type: question.detail_type,
											price: question.price,
											reference: question.conditionals.question_reference ? question.conditionals.question_reference : ""
										});
									}
								});

								this.bookingSummaryData = this.bookingSummaryData.map(question => {
									const updatedName = question.name.replace(/\{(.*?)\}/g, (match, refKey) => {
										const trimmedRef = refKey.trim();
										const found = this.bookingSummaryData.find(q => q.reference == trimmedRef);
										return found ? found.answer : match;
									});
									return {
										...question,
										name: updatedName
									};
								});


								this.datastoreService.companyQuestions.forEach((question) => {
									if (
										this.datastoreService.companyQuestionsForm.value[
										question['id']
										]
									) {
										this.companySummaryData.push({
											name: question.name,
											answer:
												this.datastoreService.companyQuestionsForm.value[
												question.id
												],
											detail_type: question.detail_type,
											price: question.price,
											reference: question.conditionals.question_reference ? question.conditionals.question_reference : ""
										});
									}
								});

								// Check if the questions contain any other purchase details
								const extraDetails = this.bookingSummaryData.filter(
									(elem) => elem.detail_type !== 'check-price'
								);
								extraDetails.length > 0
									? (this.extraDetailsPresent = true)
									: (this.extraDetailsPresent = false);
								// Calculate purchase total
								const paidItems = this.bookingSummaryData.filter(
									(item) => item.detail_type === 'check-price'
								);
								this.total =
									paidItems
										.map((items) => items.price)
										.reduce((a, b) => a + b, 0) + this.selectedService?.price;
							});

							// Get the selected slot
							this.availabilityService.getSelectedSlot().then((slot) => {
								this.selectedSlot = slot;
								console.log(slot);
							});
							this.spinner.hide();
						}
					});
				}
			}
		});
		if (this.adminJourney) {
			this.adminForm = new UntypedFormGroup({});

			const adminAmount = new UntypedFormControl('', [Validators.required]);
			const adminRef = new UntypedFormControl('', [Validators.required]);
			const adminCertRemoval = new UntypedFormControl('');
			const adminNoteStatus = new UntypedFormControl('', [Validators.required]);

			this.adminForm.addControl('amount', adminAmount);
			this.adminForm.addControl('reference', adminRef);
			this.adminForm.addControl('certificate_removal', adminCertRemoval);
			this.adminForm.addControl('note', adminNoteStatus);
		}
	}

	getDOB(dateString) {
		const birthDate = new Date(dateString);
		return moment(birthDate).format('DD/MM/YYYY');
	}

	getTermsAndConditions() {
		// Loop through all the extra pre defined fields
		const extraQuestions = this.selectedDepartment.extra;
		for (const key in extraQuestions) {
			if (extraQuestions.hasOwnProperty(key)) {
				const element = extraQuestions[key];
				if (key.indexOf('terms_and_conditions') >= 0) {
					if (!this.tncPolicy) {
						this.tncPolicy += element;
					} else {
						this.tncPolicy += ' ' + element;
					}
				}
				if (!this.tncPolicy || this.tncPolicy === '') {
					console.log('setting tncPolicy');
					this.tncPolicy =
						'Registration information is retained indefinitely as required by law. Information collected during the booking of appointments and ceremonies, including certificate orders, is retained for 2 years from the date of the appointment or ceremony.';
				}

				if (key.indexOf('service_policy') >= 0) {
					if (!this.servicePolicy) {
						this.servicePolicy += element;
					} else {
						this.servicePolicy += ' ' + element;
					}
				}
				if (!this.servicePolicy || this.servicePolicy === '') {
					this.servicePolicy =
						"Please read the Lincolnshire Registration Service <a href='https://res.cloudinary.com/bookinglab/image/upload/v1742564813/Ceremony_-_Terms_and_Conditions_k5a0j7.pdf' target='_blank'>Terms and Conditions</a> and confirm you agree.";
				}

				if (key.indexOf('privacy_statement_text') >= 0) {
					if (!this.dataPolicy) {
						this.dataPolicy += element;
					} else {
						this.dataPolicy += ' ' + element;
					}
				}
				if (!this.dataPolicy || this.servicePolicy === '') {
					this.dataPolicy = 'data policy not set';
				}
			}
		}
	}

	// create client
	async createClient(adminJourney: boolean): Promise<boolean> {
		const customerQs = [];
		let clientCreated = false;

		// For each question in the form check if the customer question exists and if so add to customerAnswers []
		for (const control in this.datastoreService.customerDetailsForm.value) {
			if (
				this.datastoreService.customerDetailsForm.value.hasOwnProperty(control)
			) {
				const element =
					this.datastoreService.customerDetailsForm.value[control];
				const question = this.datastoreService.customerQuestions.filter(
					(question) => question.id.toString() === control
				);
				let q = {};
				if (question.length > 0 && element !== '') {
					q = {
						id: question[0].id,
						answer: element,
					};

					customerQs.push(q);
				}
			}
		}

		const customerDetailsValue = this.datastoreService.customerDetailsForm;

		const password = generator.generate({
			length: 10,
			numbers: true,
		});

		const params = {
			first_name: customerDetailsValue.controls.first_name.value,
			last_name: customerDetailsValue.controls.last_name.value,
			email: customerDetailsValue.controls.email_address.value,
			mobile: customerDetailsValue.controls.contact_number.value,
			// mobile: customerDetailsValue.controls.mobile_number.value,
			// postcode: customerDetailsValue.postcode,
			// .trim()
			// .replace(" ", ""),
			member_type: '1',
			send_welcome_email: false,
			password: !adminJourney
				? customerDetailsValue.controls.password.value
				: password,
		};

		let clientRes: any;
		const found: any = await this.apiService.getBookingsForUser(
			this.selectedLocation,
			this.selectedDepartment,
			params.email
		);

		if (adminJourney) {
			// we DO NOT need to create a client in this instance.
			try {
				if (found !== 'User not found') {
					this.datastoreService.client = found;
					console.log('datastore client (pre-existing member ADMIN)', this.datastoreService.client);
					this.datastoreService.clientCreated = true;
				}
				else {
					clientRes = await this.selectedDepartment.$post(
						'client',
						{},
						params
					);
					if (clientRes) {
						this.datastoreService.client = clientRes;
						console.log('datastore client (newly created ADMIN)', this.datastoreService.client);
						this.datastoreService.clientCreated = true;
						clientCreated = true;
					}
				}
				this.store.next(true);
				// A resolved client means the journey may continue. The caller uses this as
				// its hard stop, so do not report failure just because the client already
				// existed (ARP telephony runs through here).
				return true;
			}
			catch (err) {
				this.abortCheckout('client could not be resolved', err);
				return false;
			}
		}
		else {
			try {

				if (found !== 'User not found') {
					// JRNI already holds this email, so log in as them. Never POST /client for
					// an address it already has: that is a duplicate registration, and JRNI
					// answers it with `401 Please Login`.
					//
					// This used to be gated on `found.member_type == 1`, which defeated the
					// `found !== 'User not found'` check it sits inside — any other record fell
					// through to exactly the re-registration that check exists to prevent. The
					// 401 was caught and only logged, so store.next(true) never fired and the
					// customer sat on "Processing... Please Wait" for ever. Those records are
					// ordinary returning customers: the sibling appointments app registers
					// people as member_type 2 and both apps share one JRNI client pool.
					// member_type plays no part in SSO — generateSSOToken/ssoLogin take only
					// first_name, last_name and email — so every found record takes this path.
					console.log('found existing JRNI record', {
						id: found.id,
						member_type: found.member_type,
						company_id: found.company_id,
						deleted: found.deleted,
					});
					const ssoRes = await this.ssoExistingClient(params);
					if (!ssoRes) {
						// ssoExistingClient() has already hidden the spinner and told the
						// customer. Stop here — never fall through to registration.
						return false;
					}
					clientRes = ssoRes;
				} else {
					try {
						const currentAuthToken = localStorage.getItem('auth_token');
						if (currentAuthToken) {
							localStorage.setItem('_original_auth_token', currentAuthToken);
						}
						clientRes = await this.selectedDepartment.$post('client', {}, params);
						if (clientRes) {
							this.datastoreService.client = clientRes;
							console.log('datastore client', this.datastoreService.client);
							this.datastoreService.clientCreated = true;
							const newAuthToken = localStorage.getItem('auth_token');
							if (newAuthToken) {
								localStorage.setItem('_new_auth_token', newAuthToken);
							}
							if (currentAuthToken) {
								localStorage.setItem('auth_token', currentAuthToken);
							}
							this.store.next(true); // update behavior subject using the original basket
						}
					} catch (err) {
						console.error('Client registration failed, falling back to SSO', err);
						// The email exists after all — created between our lookup and this POST,
						// or the lookup missed it. Log in rather than retrying a registration
						// JRNI has just refused.
						const ssoRes = await this.ssoExistingClient(params);
						if (!ssoRes) {
							return false;
						}
						clientRes = ssoRes;
					}
				}

				// Clear the basket
				try {
					// Clear the basket
					// await this.basketService.deleteAllBaskets(this.selectedDepartment);
					// this.basketService.currentBasket = await this.basketService.createBasket(this.selectedDepartment);
				} catch (err) {
					this.alertService.error(
						this.translateService.instant('COMMON.GENERAL_ERR')
					);
				}

				if (clientRes) {
					return true;
				} else {
					// preBasketPayment() stops on false without touching the spinner, so this
					// exit must say so itself.
					this.abortCheckout('client registration returned nothing', clientRes);
					return false;
				}
			} catch (err) {
				this.abortCheckout('client could not be resolved', err);
				return false;
			}
		}

	}

	async addItem() {
		// Get the selected slot from the previous page
		const selectedSlot = await this.availabilityService.getSelectedSlot();

		// Get the booking answers and add them to an array ready to add to basket
		for (const key in this.datastoreService.bookingForm.value) {
			{
				this.bookingAnswers.push({
					id: key,
					answer: this.datastoreService.bookingForm.value[key],
				});
			}
		}
		for (const key in this.datastoreService.companyQuestionsForm.value) {
			{
				const isAuxPostcode = key.startsWith('postcode_') || (key.endsWith('_postcode') && key.slice(0, -9) in this.datastoreService.companyQuestionsForm.value);
				if (!isAuxPostcode) {
					this.bookingAnswers.push({
						id: key,
						answer: this.datastoreService.companyQuestionsForm.value[key],
					});
				}
			}
		}
		for (const key in this.datastoreService.companyAnswers.value) {
			{
				if (!key.includes('postcode')) {
					// ditch any postcode lookups
					this.bookingAnswers.push({
						id: key,
						answer: this.datastoreService.companyAnswers.value[key],
					});
				}
			}
		}

		for (const key in this.datastoreService.serviceFees) {
			const question = this.datastoreService.serviceFees[key];
			if (question.questionId) {
				this.bookingAnswers.push({
					id: question.questionId,
					answer: question.answer,
				});
			}
		}

		// const questions = (await this.questionsService.getCompanyQuestions().toPromise())['_embedded']
		// const altQuestions = (await this.questionsService.getAltCompanyQuestions().toPromise())['_embedded']

		// const altQuestions:any = await this.questionsService.getAltCompanyQuestions().toPromise().then(questions => {return questions})
		// add the extra questions from the departments page
		// we do all this because we get the answers to several questions before we know the service
		//so we need to convert the base service's questions too the alt ones, and the only shared identifier (that we can access) is name
		if (this.datastoreService.companyQuestions) {
			for (const key in this.datastoreService.companyQuestionsForm.value) {
				const myQuestion = this.datastoreService.companyQuestions.filter(
					(x) => x.id.toString() === key
				)[0];
				// const myALtQuestion = altQuestions.questions.filter(x => x.name === myQuestion.name)[0]
				if (myQuestion) {
					if (myQuestion.length > 0) {
						this.bookingAnswers.push({
							id: key,
							answer: this.datastoreService.companyQuestionsForm.value[key],
						});
					}
				}
				// if(myALtQuestion !== undefined){
				//   this.bookingAnswers.push({
				//     id: myALtQuestion.id,
				//     answer: this.datastoreService.companyQuestionsForm.value[key],
				//   });
				// } else{
				//   alert("administrative error: Denbigh and Ruthin's question titles must match those of the other companies (this includes both translations)")
				//   return
				// }
			}
		}
		// Is the booking in Welsh, Auto populate this question
		// const usingWelsh = this.translateService.currentLang == "cy" ? 'Welsh' : 'English';
		// this.bookingAnswers.push({ id: 271, answer: usingWelsh })
		// this.bookingAnswers.push({ id: 39, answer: usingWelsh })

		this.datastoreService.bookingAnswers = this.bookingAnswers;

		// Add item to the basket
		// const res = await this.basketService.updateItemV1(
		//   this.selectedLocation,
		//   this.selectedService.id,
		//   this.selectedService.calculated_duration,
		//   selectedSlot.start,
		//   this.bookingAnswers,
		//   this.datastoreService.client.id,
		//   this.selectedResource
		// )

		if (this.datastoreService.adminJourney) {
			try {
				const updateServiceItem = await this.basketService.updateItemV1(
					this.selectedLocation,
					this.selectedService.id,
					this.selectedService.calculated_duration,
					selectedSlot.start,
					[],
					this.datastoreService.client.id,
					this.selectedResource
				);
				console.log(updateServiceItem);
				// api.service swallows HTTP failures and returns the error message as a STRING
				// instead of throwing, so a failed update reads as success here. Anything that is
				// not a service item means the item still carries the resource JRNI auto-assigned
				// — i.e. the wrong room — so fail loudly rather than paying for it.
				if (!updateServiceItem || typeof updateServiceItem !== 'object') {
					throw new Error(
						`Service item update failed: ${JSON.stringify(updateServiceItem)}`
					);
				}
				return updateServiceItem;
			} catch (err) {
        console.log(3);
				console.error(err);
				this.alertService.error(
					this.translateService.instant('SUMMARY.INVALID_SLOT')
				);
				this.spinner.hide();
				this.scrollToTop();
				throw err;
			}
		} else {
			try {
				const updateServiceItem = await this.apiService.updateServiceItem(
					this.selectedLocation,
					this.basketService.currentBasket,
					this.basketService.currentServiceItem,
					{
						company_id: this.selectedLocation.id,
						service_id: this.selectedService.id,
						duration: this.selectedService.calculated_duration,
						start: `${selectedSlot.start}`,
						resource_id: this.apiService.resolveResourceId(
							this.selectedResourceObj,
							this.selectedResource
						),
						questions: [],
					}
				);

				console.log(updateServiceItem);
				// api.service swallows HTTP failures and returns the error message as a STRING
				// instead of throwing, so a failed update reads as success here. Anything that is
				// not a service item means the item still carries the resource JRNI auto-assigned
				// — i.e. the wrong room — so fail loudly rather than paying for it.
				if (!updateServiceItem || typeof updateServiceItem !== 'object') {
					throw new Error(
						`Service item update failed: ${JSON.stringify(updateServiceItem)}`
					);
				}
				return updateServiceItem;
			} catch (err) {
        console.log(4);
				console.error(err);
				this.alertService.error(
					this.translateService.instant('SUMMARY.INVALID_SLOT')
				);
				this.spinner.hide();
				this.scrollToTop();
				throw err;
			}
		}
	}

	/**
	 * What the fee lines say the booking is worth, whichever payment option the
	 * customer picked. Used only to tell a genuinely free booking (no priced
	 * lines at all) apart from one we failed to work out a charge for.
	 */
	private feeLinesTotal(): number {
		const fees = Array.isArray(this.datastoreService.serviceFees)
			? this.datastoreService.serviceFees
			: [];
		return fees.reduce(
			(sum, fee) =>
				sum + (Number(fee?.cost) || 0) * (Number(fee?.quantity) || 0),
			0
		);
	}

	async startCheckout(telephony: boolean) {
		if (this.datastoreService.feesUnavailable) {
			// /fees answered 404 for this selection: it has no configured price. An
			// unpriced ceremony must never check out at £0 — route the customer to
			// the register office instead.
			this.alertService.error(
				'We are unable to calculate the fee for this booking, so it cannot be completed online. Please contact the register office.'
			);
			this.scrollToTop();
			return;
		}
		// Only the paying paths: adminCheckout() books without taking payment, so a
		// zero total is normal there. Telephony (ARP) does pay, so it is included.
		const willTakePayment = !this.adminJourney || telephony;
		if (
			willTakePayment &&
			this.feeLinesTotal() > 0 &&
			!(Number(this.datastoreService.totalCost) > 0)
		) {
			// The booking owes money but the amount we would hand the gateway is £0
			// — how a deposit used to collapse when /fees priced no booking fee.
			// Every gateway on the estate opens no payment page for a zero total and
			// returns an empty redirect URL, so the customer is either stranded or,
			// worse, booked without paying. Free bookings have no priced lines and
			// never reach this branch.
			console.error(
				'startCheckout: fee lines total',
				this.feeLinesTotal(),
				'but payable is',
				this.datastoreService.totalCost,
				'— refusing to send a zero payment'
			);
			this.alertService.error(
				'We are unable to take payment for this booking online. Please contact the register office.'
			);
			this.scrollToTop();
			return;
		}
		// if (!this.adminJourney) {
    //   console.log(this.customerQuestions);
		// 	this.customerQuestions.forEach((question) => {
		// 		this.customerDetailsForm.controls[question.id].markAsTouched();
		// 	});
		// }
		if (this.adminJourney) {
			this.adminFormSubmitted = true;
			if (!telephony) {
				if (this.adminForm.valid) {
					// do some admin stuff
					this.checkoutStarted = true;
					this.spinner.show();

					// Check if selected slot is still available
					let slotAvailable: boolean;

					await this.apiService
						.checkSlotAvailability(
							this.selectedDepartment,
							this.selectedSlot.start
						)
						.then((res: any) => {
							slotAvailable = res.available;
						});

					if (slotAvailable === false) {
						// If unavailable, then alert user
            console.log(5);
						this.alertService.error(
							this.translateService.instant('SUMMARY.INVALID_SLOT')
						);
						this.scrollToTop();
						this.slotAvailable = false;
						this.spinner.hide();
						this.checkoutStarted = false;
					} else {
						// If available then checkout
						// this.checkout()
						if (!telephony) {
							await this.adminCheckout();
						}
					}
				}
			}
			else {
				this.checkoutStarted = true;
				this.spinner.show();

				// Check if selected slot is still available
				let slotAvailable: boolean;

				await this.apiService
					.checkSlotAvailability(
						this.selectedDepartment,
						this.selectedSlot.start
					)
					.then((res: any) => {
						slotAvailable = res.available;
					});

				if (slotAvailable === false) {
					// If unavailable, then alert user
          console.log(6);
					this.alertService.error(
						this.translateService.instant('SUMMARY.INVALID_SLOT')
					);
					this.scrollToTop();
					this.slotAvailable = false;
					this.spinner.hide();
					this.checkoutStarted = false;
				} else {
					// If available then checkout
					// this.checkout()
					await this.telephonePayment();
				}
			}
		} else {
			this.checkoutStarted = true;
			this.spinner.show();

			// Check if selected slot is still available
			let slotAvailable: boolean;

			try {
				await this.apiService
					.checkSlotAvailability(this.selectedDepartment, this.selectedSlot.start)
					.then((res: any) => {
						slotAvailable = res.available;
					});

				if (slotAvailable === false) {
					// If unavailable, then alert user
					this.alertService.error(
						this.translateService.instant('SUMMARY.INVALID_SLOT')
					);
					this.scrollToTop();
					this.slotAvailable = false;
					this.spinner.hide();
					this.checkoutStarted = false;
				} else {
					const priceData = await this.preCheckoutExtras();
					console.log('priceData', priceData);
					await this.preBasketPayment(priceData.paymentAmount, false);
				}
			} catch (err) {
				// checkSlotAvailability() returns the raw promise, so a network failure or a
				// 5xx rejects straight out of here.
				this.abortCheckout('checkout could not be started', err);
			}
		}
	}

	async telephonePayment() {
		this.checkoutStarted = true;
		this.spinner.show();

		// Check if selected slot is still available
		let slotAvailable: boolean;

		try {
			await this.apiService
				.checkSlotAvailability(this.selectedDepartment, this.selectedSlot.start)
				.then((res: any) => {
					slotAvailable = res.available;
				});

			if (slotAvailable === false) {
				// If unavailable, then alert user
				this.alertService.error(
					this.translateService.instant('SUMMARY.INVALID_SLOT')
				);
				this.scrollToTop();
				this.slotAvailable = false;
				this.spinner.hide();
				this.checkoutStarted = false;
			} else {
				const priceData = await this.preCheckoutExtras();
				console.log('priceData', priceData);
				await this.preBasketPayment(priceData.paymentAmount, true);
			}
		} catch (err) {
			this.abortCheckout('checkout could not be started', err);
		}
	}

	async preBasketPayment(amount, telephony) {
		// Resolve the PARENT company id (e.g. 37002 ceremonies) — NOT the child/location
		// company — to send as company_id on the pre-basket call. Falls back to null + warn.
		const parentCompanyId = AppConfig.settings.core.company_id || null;
		if (!parentCompanyId) {
			console.warn('[preBasket] Parent company_id could not be resolved from config; sending company_id as null');
		}
		const clientResolved = await this.createClient(this.adminJourney);
		if (!clientResolved) {
			// createClient() has already hidden the spinner and told the customer what
			// went wrong. Do not subscribe: nothing will ever emit and the journey would
			// sit on "Processing... Please Wait".
			return;
		}
		// The client handshake and the post-SSO basket rebuild are both asynchronous
		// and neither is guaranteed to emit.
		this.startCheckoutWatchdog();
		this.store.asObservable().subscribe(async (state) => {
			console.log('state', state);
			if (state) {
				console.log('client created');
				let updatedItem;
				try {
					updatedItem = await this.addItem();
				} catch (err) {
					// addItem() has already surfaced the error to the customer. Do not fall through:
					// the service item can still hold whatever resource JRNI auto-assigned, which is
					// exactly how bookings land on the wrong resource.
					console.error('Aborting checkout — service item update failed', err);
					this.checkoutStarted = false;
					this.spinner.hide();
					return;
				}
				// addedItem was seeded false and never emitted, so the payment block ran even
				// when the update failed. Emit the real item now that we know it succeeded.
				this.addedItem.next(updatedItem);
				this.addedItem.asObservable().subscribe(async (item) => {
					try {
					if (
						this.departmentService.selectedDepartment.hasOwnProperty('extra') &&
						this.departmentService.selectedDepartment.extra.hasOwnProperty(
							'login_required'
						)
					) {
						this.departmentService.selectedDepartment.extra.login_required.toLowerCase() ===
							'yes'
							? (this.member = await this.memberService.getMember())
							: (this.member = await this.datastoreService.client);
					} else {
						this.member = await this.datastoreService.client;
					}

					const currentBasket = await this.basketService.currentBasket;
					console.log('currentBasket', currentBasket);
					const serviceItem = this.basketService.currentServiceItem;

					const authToken = localStorage.getItem('auth_token');

					const tmpFees: any[] = JSON.parse(
						JSON.stringify(this.datastoreService.serviceFees)
					);
					tmpFees.unshift(this.ceremonyFee);

					if (amount > 0) {
						if (!telephony) {
							const descriptions = [this.selectedService.name];
							const serviceItemsToSend = [];
							let pmtTyp = '';
							const extraItem:any = await this.apiService.getExtraItem(
									this.selectedDepartment.id,
									this.selectedService.id,
									this.selectedService.extra?.fees_extra_item_id
								);
								console.log('extraItem', extraItem);
							if (extraItem && extraItem) {
								pmtTyp = extraItem.data.short_code;
							} else {
								pmtTyp =
									this.selectedService.extra &&
										this.selectedService.extra?.short_code
										? this.selectedService.extra?.short_code
										: '';
							}

							const fundCode =
								this.selectedService.extra &&
									this.selectedService.extra?.gl_code
									? this.selectedService.extra?.gl_code
									: '';

							// Build amounts as an array of objects: ceremonyFee first, then extra items
							const amounts = [];
							const ceremonyChargeObj: any = {
								charge: this.ceremonyFee ? this.ceremonyFee.cost : 0,
								chargeName: this.ceremonyFee?.item || this.selectedService.name
							};
							if (extraItem && extraItem.data) {
								if (extraItem.data.gl_code) {
									ceremonyChargeObj.glCode = extraItem.data.gl_code;
								}
								if (extraItem.data.short_code) {
									ceremonyChargeObj.reference = extraItem.data.short_code;
								}
							}
							amounts.push(ceremonyChargeObj);
							for (const fee of this.datastoreService.serviceFees) {
								const chargeObj: any = {
									charge: fee.cost * parseInt(fee.quantity || '1'),
									chargeName: fee.item
								};
								let feeExtraItemId = null;
								if (fee.item_id) {
									feeExtraItemId = fee.item_id;
								} else if (fee.questionid) {
									const question = this.datastoreService.serviceQuestionSchema[this.datastoreService.selectedSchema]?.schema?.fields?.find(
										(q) => q.field == fee.questionid
									);
									if (question && question['extra-item']) {
										feeExtraItemId = question['extra-item'];
									}
								}
								if (feeExtraItemId) {
									try {
										const feeExtraItem: any = await this.apiService.getExtraItem(
											this.selectedDepartment.id,
											this.selectedService.id,
											feeExtraItemId
										);
										if (feeExtraItem && feeExtraItem.data) {
											if (feeExtraItem.data.gl_code) {
												chargeObj.glCode = feeExtraItem.data.gl_code;
											}
											if (feeExtraItem.data.short_code) {
												chargeObj.reference = feeExtraItem.data.short_code;
											}
											if (feeExtraItem.data.vat_code) {
												chargeObj.vatCode = feeExtraItem.data.vat_code;
											}
											if (feeExtraItem.data.vat_rate) {
												chargeObj.vatRate = feeExtraItem.data.vat_rate;
											}
											chargeObj.id = feeExtraItem.item_id;
											descriptions.push(feeExtraItem.item_name);
										}
									} catch (err) {
										console.log('Error fetching extra item for fee', fee, err);
									}
								}
								amounts.push(chargeObj);
							}
							console.log('amounts array', amounts);

              // Deposit path collapses to the scalar amount contract: Capita
              // sums additionalCharges[].charge when sent as array, so the
              // array path always bills the full balance. The deposit value
              // already lives in dataStore.totalCost (set by
              // fees-and-make-it-yours-enhancements.calculateTotal()).
              const isDeposit =
                this.datastoreService.makeItYoursPaymentType === 'deposit';
              const sendAmount = isDeposit
                ? this.datastoreService.totalCost
                : amounts;
              const sendDescriptions = isDeposit
                ? [this.selectedService.name]
                : descriptions;

              if (serviceItem.hasOwnProperty('id')) {
                serviceItemsToSend.push({ id: serviceItem.id });

                const redir: any = await this.capitaService.preBasketInvoke(
                  this.selectedLocation,
                  this.selectedService,
                  currentBasket,
                  [serviceItem],
                  sendDescriptions,
                  this.member,
                  fundCode,
                  sendAmount,
                  authToken,
                  {
                    fees: tmpFees,
                    firstAvailableSlot: this.datastoreService.firstSlotAnalytic ? this.datastoreService.firstSlotAnalytic : "Null",
                    lookupResponses: this.datastoreService.lookupResponses,
                    selectedAddress: this.datastoreService.selectedAddress,
                    schema: this.datastoreService.selectedSchema,
                    bookingQuestions: this.datastoreService.bookingAnswers,
                    revision: this.datastoreService.serviceQuestionSchema[this.datastoreService.selectedSchema].revision,
                  },
                  this.selectedService.detail_group_id,
                  this.selectedSlot,
                  this.datastoreService.extraDuration,
                  'ceremony',
                  pmtTyp,
                  parentCompanyId
                );

                if (redir && redir.url) {
                  console.log('REDIR', redir);
                  this.clearCheckoutWatchdog();
                  localStorage.setItem('resource', JSON.stringify(this.selectedResourceObj));
                  window.location = redir.url;
                  // this.spinner.hide();
                } else {
                  console.error(`No URL returned from payment gateway`);
                  this.checkoutStarted = false;
                  this.checkoutFailed = true;
				  //free up the slot
				  const cancelled = await this.apiService.deleteBaskets(this.selectedLocation);
				  if (!cancelled) {
					console.error('Failed to clear basket after payment failure');
				  }
                  this.spinner.hide();
				  this.scrollToTop();
                }
              }
              else {
                console.error(`Service iterm is undefined`);
                this.alertService.error(
                  this.translateService.instant('COMMON.LOAD_ISSUE')
                );
                this.spinner.hide();
              }
						} else {
							// get the admin user first
							let pmtTyp = '';
							const extraItem: any = await this.apiService.getExtraItem(this.selectedDepartment.id, this.selectedService.id, this.selectedService.extra?.fees_extra_item_id);
							if (extraItem) {
								pmtTyp = extraItem.data.pmtTyp;
							}
							else {
								pmtTyp = this.selectedService.extra && this.selectedService.extra?.pmttyp ? this.selectedService.extra?.pmttyp : ''
							}
							// const adminUser = admins._embedded.administrators[0];
							let userRole = 'Administrator';
							let adminUser;
							let adminPhone;
							let userId;
							try {
								adminUser = JSON.parse(localStorage.getItem('agent'));
								console.log('adminUser', adminUser);
								if (adminUser) {
									const adminProfile: any = JSON.parse(
										localStorage.getItem('agent_profile')
									);
									userId = adminProfile.mail.split('@')[0];

									let userRole = adminUser.role;
									if (userRole === 'callcenter') {
										userRole = 'Call Centre';
									} else {
										userRole = 'Administrator';
									}
								}
								else {
									const adminTmp: any = JSON.parse(localStorage.getItem('admin_user'));
									adminUser = {
										id: adminTmp.email,
										email: adminTmp.email
									};
									userRole = 'Administrator';
								}
							}
							catch (err) {
								userRole = 'Administrator';
							}
							console.log('adminUser', adminUser);
							const serviceItemsToSend = [];
              if (serviceItem.hasOwnProperty('id')) {
                serviceItemsToSend.push({ id: serviceItem.id });
                console.log('serviceItemsToSend', serviceItemsToSend);
                // const redir: any =
                //   await this.heyCentricService.preBasketTelephonyInvoke(
                //     this.selectedLocation,
                //     currentBasket,
                //     serviceItemsToSend,
                //     [this.selectedService.name],
                //     this.member,
                //     pmtTyp,
                //     amount,
                //     authToken,
                //     {
                //       fees: tmpFees
                //     },
                //     this.datastoreService.type_of_ceremony,
                //     this.selectedSlot,
                //     this.datastoreService.extraDuration,
                //     'M2',
                //     userId,
                //     adminUser.email,
                //     adminPhone
                //   );

                // if (redir.url) {
                //   console.log('REDIR', redir);
                //   window.location = redir.url;
                //   // this.spinner.hide();
                // } else {
                //   console.error(`No URL returned from payment gateway`);
                //   this.alertService.error(
                //     this.translateService.instant('COMMON.LOAD_ISSUE')
                //   );
                //   this.spinner.hide();
                // }
              }
              else {
                console.error(`Service iterm is undefined`);
                this.alertService.error(
                  this.translateService.instant('COMMON.LOAD_ISSUE')
                );
                this.spinner.hide();
              }
						}
					} else {
            this.alertService.error(
              "There was a problem initiating payment for your ceremony. Please try again."
            );
            this.spinner.hide();
						// await this.postBasketCheckout(
						// 	this.selectedLocation,
						// 	this.basketService.currentBasket,
						// 	this.member
						// );
					}
					} catch (err) {
						// An async callback passed to subscribe() has nowhere to throw, so a
						// rejection in here used to be swallowed by RxJS and the customer sat on
						// "Processing... Please Wait". Everything below the spinner must end in a
						// redirect or a visible error.
						this.abortCheckout('payment could not be started', err);
					}
				});
			}
		});
	}

	async postBasketCheckout(company, basket, client) {
		const checkout: any = await this.apiService.basketCheckout(
			company,
			basket,
			{ id: client.id }
		);

		console.log(checkout);
		const purchase: any = await this.apiService.findPurchase(
			this.selectedLocation,
			checkout.id
		);
		console.log(purchase);

		const booking = purchase._embedded.bookings[0];
		const member = purchase._embedded.client;
		this.member = member;
		this.datastoreService.booking = booking;
		this.datastoreService.purchase = purchase;
		console.log(booking);

		// await this.apiService.sendFrontSheetEmail(booking); // sendCommunicationEmail
		let ceremonyFee;
		try {
			if (this.datastoreService.serviceFees.length > 0) {
				// find ceremony base cost
				const noQuestionId = this.datastoreService.serviceFees.find(
					(item) => item.questionid == undefined
				);
				console.log('noQuestionId', noQuestionId);
				if (noQuestionId) {
					ceremonyFee = noQuestionId;
					// remove the base cost from the array
					this.datastoreService.serviceFees =
						this.datastoreService.serviceFees.filter(
							(item) => item.questionid !== undefined
						);
				}
			}
			console.log('ceremonyFee', ceremonyFee);

			// ceremonyFee = this.datastoreService.serviceFees.shift();
		} catch (err) {
			console.log(err);
		}

		let paymentAmount = 0;
		let bookingPrice = 0;
		let chargePrice = 0;
		let certs = 0;
		let foundExtraItemIds = [];
		let foundExtraItemCharges = [];

		let certsToRemoveCount = 0;

		try {
			// link booking to extra item ONLY IF we are not an admin journey, but we always want to calculate the price.
			if (this.datastoreService.config.hasOwnProperty('journey_config')) {
				if (
					this.datastoreService.config.journey_config.hasOwnProperty(
						'appointments'
					)
				) {
					// if (this.datastoreService.config.journey_config.ceremonies.hasOwnProperty('fees_extra_item_id')) {
					//   const extraItem = this.datastoreService.config.journey_config.ceremonies.fees_extra_item_id.trim();
					//   await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem, ceremonyFee);
					// }
					if (this.datastoreService.selectedService.extra?.fees_extra_item_id) {
						const extraItem =
							this.datastoreService.selectedService.extra?.fees_extra_item_id.trim();
						if (extraItem && extraItem.length > 0) {
							// paymentAmount += ceremonyFee.deposit;
							paymentAmount = this.datastoreService.totalCost;
							bookingPrice += ceremonyFee.cost;
							// if (!this.adminJourney) {
							await this.apiService.linkExtraItem(
								this.selectedLocation.id,
								this.datastoreService.selectedService.id,
								booking.id,
								extraItem,
								ceremonyFee
							);
							// }
						}
					}
					// now link other items
					for (const extraItem of this.datastoreService.serviceFees) {
						if (extraItem.questionid) {
							const question = this.datastoreService.companyQuestions.find(
								(q) => q.id == extraItem.questionid
							);
							if (question) {
								if (question.help_text) {
									const schema: any = JSON.parse(question.help_text);
									if (schema['extra-item']) {
										const extraItemId = schema['extra-item'];
										foundExtraItemIds.push(extraItemId);
										foundExtraItemCharges.push(
											extraItem.cost * parseInt(extraItem.quantity)
										);
										// if (question.id == this.datastoreService.config.journey_config.ceremonies.included_certificates_question) {
										// paymentAmount += (extraItem.cost * parseInt(extraItem.quantity));
										// bookingPrice += (extraItem.cost * parseInt(extraItem.quantity));
										// chargePrice += extraItem.cost;
										bookingPrice +=
											extraItem.cost * parseInt(extraItem.quantity);
										// bookingPrice += extraItem.cost;
										// }
										certs++;
										// Always link extra items
										// if (!this.adminJourney) {
										await this.apiService.linkExtraItem(
											this.selectedLocation.id,
											this.datastoreService.selectedService.id,
											booking.id,
											extraItemId,
											extraItem
										);
										// }
									} else {
										console.log('Missing extra item');
									}
								} else {
									console.log('Missing schema');
								}
							} else {
								console.log(`Cant find question ${extraItem.questionid}`);
								chargePrice += extraItem.cost;
								bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
								await this.apiService.linkExtraItem(
									this.selectedLocation.id,
									this.datastoreService.selectedService.id,
									booking.id,
									extraItem.item_id,
									extraItem
								);
							}
						} else {
							console.log('No question ID on extra item');
							chargePrice += extraItem.cost;
							bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
							await this.apiService.linkExtraItem(
								this.selectedLocation.id,
								this.datastoreService.selectedService.id,
								booking.id,
								extraItem.item_id,
								extraItem
							);
						}
					}
				}
			}
		} catch (err) {
			console.log(err);
		}

		if (this.datastoreService.selectedService.extra?.online_payment == 'Yes') {
			try {
				console.log(`Booking price: ${bookingPrice}`);
				// now we update the price of the booking
				await this.apiService.updatePrice(
					this.selectedLocation,
					booking.id,
					purchase.id,
					`${bookingPrice * 100}`,
					'0'
				);

				localStorage.setItem('booking', JSON.stringify(booking));
				// set the resource, the date time and the location, the booking all on localstorage
				// localStorage.setItem('resource', JSON.stringify(this.selectedResourceObj));
				localStorage.setItem('date', JSON.stringify(this.selectedSlot));
				localStorage.setItem('location', JSON.stringify(this.selectedLocation));
				localStorage.setItem('booking', JSON.stringify(booking));
				localStorage.setItem('service', JSON.stringify(this.selectedService));

				const authToken: string = localStorage.getItem('auth_token');
				console.log('authToken', authToken);
				const extra: any =
					await this.apiService.getServiceItemExtraLinksForBooking(
						booking.company_id,
						booking.id,
						authToken,
						this.member.id
					);
				console.log(extra);
				let payCallNote = '';
				let note = `Payment type: `;
				let hasDeposit = false;
				if (extra && extra.length > 0) {
					for (const item of extra) {
						if (
							item.item_id !==
							this.datastoreService.selectedService.extra?.fees_extra_item_id
						) {
							if (item.data && item.data.quantity) {
								certs = parseInt(item.data?.quantity);
							}
							break;
						}
					}
					for (const item of extra) {
						if (
							item.item_id ===
							this.datastoreService.selectedService.extra?.fees_extra_item_id
						) {
							// now we know the deposit and full fee value
							if (item.data.deposit !== item.data.cost) {
								const daysAway = moment(booking.datetime).diff(moment(), 'd');
								if (daysAway > 182) {
									note = `${note} Ceremony Fee Deposit`;
									payCallNote = `Ceremony Fee Deposit`;
									if (certs > 0) {
										note = `${note} & Certificates in Full`;
										payCallNote = `${payCallNote} & Certificates in Full`;
									}
									hasDeposit = true;
								} else {
									note = `${note} Ceremony Fee`;
									payCallNote = `Ceremony Fee`;
									if (certs > 0) {
										note = `${note} & Certificates in Full`;
										payCallNote = `${payCallNote} & Certificates in Full`;
									}
								}
							} else {
								note = `${note} Ceremony Fee`;
								payCallNote = `Ceremony Fee`;
								if (certs > 0) {
									note = `${note} & Certificates in Full`;
									payCallNote = `${payCallNote} & Certificates in Full`;
								}
							}
						}
					}
				}
				// now update the note
				note += ` | Deposit? ${hasDeposit ? 'Yes' : 'No'}`;
				if (certs > 0) {
					note += ` | Number of certificates: ${certs}`;
				}
				note += ` | Deposit payment date: ${moment()
					.tz('Europe/London')
					.format('dddd, MMMM Do YYYY')}`;
				try {
					await this.apiService.payPurchase(
						this.selectedLocation.id,
						booking.service_id,
						booking.purchase_id,
						{
							amount: bookingPrice,
							transaction_id: ``,
							notify: false,
							notify_admin: false,
							payment_status: 'paid',
							notes: `${payCallNote}`,
						},
            purchase._embedded.client.id
					);
				} catch (err) {
					console.error(err);
				}

				try {
					await this.apiService.addNoteToBooking(this.selectedLocation, booking.id, note).then(async (body: any) => {
						// Loop over booking.questions and attach images for base64 answers
						for (const key in body.questions) {
							if (body.questions.hasOwnProperty(key)) {
								const question = body.questions[key];

								if (question.answer && typeof question.answer === 'string' && question.answer.startsWith('data:image/')) {
									try {
										await this.basketService.attachImageToBooking(
											body.purchase_ref,
											body.id,
											question.answer
										);
										console.log(`Attached image for question: ${question.name}`);
									} catch (error) {
										console.error(`Error attaching image for question: ${question.name}`, error);
									}
								}
							}
						}
					});
				} catch (err) {
					console.error(err);
				}

				try {
					const config: any = this.config;
					if (
						config &&
						config.journey_config &&
						config.journey_config.hasOwnProperty('crm_push')
					) {
						if (config.journey_config.crm_push === 'osc') {
							await this.apiService.submitCaseToOracle(
								this.selectedDepartment,
								booking
							);
						}
					}
				} catch (err) {
					console.error(err);
				}

				try {
					const dontSendIds =
						this.config.journey_config.welcome_email_ignore_list;
					// dont send emails for these ids
					if (
						!dontSendIds.includes(
							this.datastoreService.selectedService.global_id
						)
					) {
						await this.apiService.sendWelcomeEmail(
							this.selectedLocation.id,
							member.id
						);
						await this.apiService.bookingTimeline(
							this.selectedLocation.id,
							booking.purchase_id,
							member.id,
							member.email
						);
					}
				} catch (err) {
					console.error(err);
				}

				this.router.navigate(['confirmation']);
				return;
			} catch (err) {
				console.error(err);
				this.spinner.hide();
				// this.apiService.logPaymentExtra(
				//   this.company,
				//   this.dataStore.selectedService,
				//   booking.purchase_id,
				//   {
				//     "purchase": booking.purchase_id,
				//     "payment_error": err
				//   }
				// );
				this.alertService.error(this.translateService.instant('PAYMENT.ERROR'));
				this.router.navigate(['locations']);
			}
		}
	}

	backToCalendar() {
		this.router.navigate(['/calendar']);
	}

	async adminCheckout() {
		this.alertService.clear();
		this.submitted = true;
		let noNotifications = true;

		const customerDetailsValue = this.datastoreService.customerDetailsForm;

		const password = generator.generate({
			length: 10,
			numbers: true,
		});

		const params = {
			first_name: customerDetailsValue.controls.first_name.value,
			last_name: customerDetailsValue.controls.last_name.value,
			email: customerDetailsValue.controls.email_address.value,
			mobile: customerDetailsValue.controls.contact_number.value,
			// mobile: customerDetailsValue.controls.mobile_number.value,
			// postcode: customerDetailsValue.postcode,
			// .trim()
			// .replace(" ", ""),
			member_type: '1',
			send_welcome_email: false,
			password: !this.adminJourney
				? customerDetailsValue.controls.password.value
				: password,
		};
		let clientRes;
		const found: any = await this.apiService.getBookingsForUser(
			this.selectedLocation,
			this.selectedDepartment,
			params.email
		);
		if (found == 'User not found') {
			// make the client
			try {
				clientRes = await this.selectedDepartment.$post('client', {}, params);
				if (clientRes) {
					this.datastoreService.client = clientRes;
					console.log('datastore client', this.datastoreService.client);
					this.datastoreService.clientCreated = true;
				}
			} catch (err) {
				console.error(err);
			}
		} else {
			// get teh clients ID
			console.log(found);
			this.datastoreService.client = found;
			// this.memberService.setMember(found);
		}
		try {
			await this.addItem();
		} catch (err) {
			// addItem() has already surfaced the error to the customer. Do not fall through:
			// the service item can still hold whatever resource JRNI auto-assigned, which is
			// exactly how bookings land on the wrong resource.
			console.error('Aborting checkout — service item update failed', err);
			this.checkoutStarted = false;
			this.spinner.hide();
			return;
		}

		if (
			this.departmentService.selectedDepartment.hasOwnProperty('extra') &&
			this.departmentService.selectedDepartment.extra.hasOwnProperty(
				'login_required'
			)
		) {
			this.departmentService.selectedDepartment.extra.login_required.toLowerCase() ===
				'yes'
				? (this.member = await this.memberService.getMember())
				: (this.member = await this.datastoreService.client);
		} else {
			this.member = await this.datastoreService.client;
		}

		// if (!this.datastoreService.adminJourney && this.datastoreService.selectedService.extra?.online_payment == 'Yes') {
		noNotifications = true;
		// }

		if (this.datastoreService.adminJourney) {
			await this.basketService
				.checkoutBasketV1(this.selectedLocation, this.member, noNotifications)
				.then(async (res: any) => {
					// Get the purchase
					await this.afterCheckout(res);
				})
				.catch((error: HttpErrorResponse) => {
					console.log(error);
					if (error['response'].status === 409) {
            console.log(9);
						this.alertService.error(
							this.translateService.instant('SUMMARY.INVALID_SLOT')
						);
					} else {
						this.alertService.error(
							this.translateService.instant('COMMON.LOAD_ISSUE')
						);
					}
					this.spinner.hide();
					this.checkoutStarted = false;
					this.scrollToTop();
				});
		} else {
			try {
				const checkout = await this.apiService.basketCheckout(
					this.selectedLocation,
					this.basketService.currentBasket,
					this.datastoreService.client
				);
				await this.afterCheckout(checkout);
			} catch (error) {
				console.error(error);
				if (error['response'].status === 409) {
          console.log(10);
					this.alertService.error(
						this.translateService.instant('SUMMARY.INVALID_SLOT')
					);
				} else {
					this.alertService.error(
						this.translateService.instant('COMMON.LOAD_ISSUE')
					);
				}
				this.spinner.hide();
				this.checkoutStarted = false;
				this.scrollToTop();
			}
		}
	}

	async checkout() {
		this.alertService.clear();
		this.submitted = true;
		let noNotifications = true;

		const clientCreated = await this.createClient(this.adminJourney);
		this.store.asObservable().subscribe(async (state) => {
			console.log('state', state);
			if (state) {
				console.log('client created');
				try {
					await this.addItem();
				} catch (err) {
					// addItem() has already surfaced the error to the customer. Do not fall through:
					// the service item can still hold whatever resource JRNI auto-assigned, which is
					// exactly how bookings land on the wrong resource.
					console.error('Aborting checkout — service item update failed', err);
					this.checkoutStarted = false;
					this.spinner.hide();
					return;
				}

				// set member as the client,if the login is not required
				if (
					this.departmentService.selectedDepartment.hasOwnProperty('extra') &&
					this.departmentService.selectedDepartment.extra.hasOwnProperty(
						'login_required'
					)
				) {
					this.departmentService.selectedDepartment.extra.login_required.toLowerCase() ===
						'yes'
						? (this.member = await this.memberService.getMember())
						: (this.member = await this.datastoreService.client);
				} else {
					this.member = await this.datastoreService.client;
				}

				// if (!this.datastoreService.adminJourney && this.datastoreService.selectedService.extra?.online_payment == 'Yes') {
				noNotifications = true;
				// }

				if (this.datastoreService.adminJourney) {
					await this.basketService
						.checkoutBasketV1(
							this.selectedLocation,
							this.member,
							noNotifications
						)
						.then(async (res: any) => {
							// Get the purchase
							await this.afterCheckout(res);
						})
						.catch((error: HttpErrorResponse) => {
							console.log(error);
							if (error['response'].status === 409) {
                console.log(11);
								this.alertService.error(
									this.translateService.instant('SUMMARY.INVALID_SLOT')
								);
							} else {
								this.alertService.error(
									this.translateService.instant('COMMON.LOAD_ISSUE')
								);
							}
							this.spinner.hide();
							this.checkoutStarted = false;
							this.scrollToTop();
						});
				} else {
					try {
						const checkout = await this.apiService.basketCheckout(
							this.selectedLocation,
							this.basketService.currentBasket,
							this.datastoreService.client
						);
						await this.afterCheckout(checkout);
					} catch (error) {
						console.error(error);
						if (error['response'].status === 409) {
              console.log(12);
							this.alertService.error(
								this.translateService.instant('SUMMARY.INVALID_SLOT')
							);
						} else {
							this.alertService.error(
								this.translateService.instant('COMMON.LOAD_ISSUE')
							);
						}
						this.spinner.hide();
						this.checkoutStarted = false;
						this.scrollToTop();
					}
				}
			}
		});
	}

	async afterCheckout(res) {
		console.log(res);
		const purchase: any = await this.apiService.findPurchase(
			this.selectedLocation,
			res.id
		);
		console.log(purchase);

		const booking = purchase._embedded.bookings[0];
		this.datastoreService.booking = booking;
		this.datastoreService.purchase = purchase;
		//
		console.log(booking);

		await this.apiService.sendFrontSheetEmail(booking); // sendCommunicationEmail
		let ceremonyFee;
		try {
			if (this.datastoreService.serviceFees.length > 0) {
				// find ceremony base cost
				const noQuestionId = this.datastoreService.serviceFees.find(
					(item) => item.questionid == undefined
				);
				console.log('noQuestionId', noQuestionId);
				if (noQuestionId) {
					ceremonyFee = noQuestionId;
					// remove the base cost from the array
					this.datastoreService.serviceFees =
						this.datastoreService.serviceFees.filter(
							(item) => item.questionid !== undefined
						);
				}
			}

			// ceremonyFee = this.datastoreService.serviceFees.shift();
		} catch (err) {
			console.log(err);
		}
		console.log(
			'this.datastoreService.adminJourney',
			this.datastoreService.adminJourney,
			'this.datastoreService.selectedService.extra?.online_payment',
			this.datastoreService.selectedService.extra?.online_payment,
			'this.datastoreService.serviceFees',
			this.datastoreService.serviceFees,
			'ceremonyFee',
			ceremonyFee
		);
		let paymentAmount = 0;
		let bookingPrice = 0;
		let chargePrice = 0;
		let certs = 0;
		const foundExtraItemIds = [];
		const foundExtraItemCharges = [];

		let certsToRemoveCount = 0;
		if (this.adminJourney) {
			const certsToRemove = this.adminForm.controls['certificate_removal'];
			if (parseInt(certsToRemove.value) > 0) {
				console.log(`We should remove ${certsToRemove.value} certificates`);
				certsToRemoveCount = parseInt(certsToRemove.value);
			}
		}

		try {
			// link booking to extra item ONLY IF we are not an admin journey, but we always want to calculate the price.
			if (this.datastoreService.config.hasOwnProperty('journey_config')) {
				if (
					this.datastoreService.config.journey_config.hasOwnProperty(
						'ceremonies'
					)
				) {
					// if (this.datastoreService.config.journey_config.ceremonies.hasOwnProperty('fees_extra_item_id')) {
					//   const extraItem = this.datastoreService.config.journey_config.ceremonies.fees_extra_item_id.trim();
					//   await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem, ceremonyFee);
					// }
					if (this.datastoreService.selectedService.extra?.fees_extra_item_id) {
						const extraItem =
							this.datastoreService.selectedService.extra?.fees_extra_item_id.trim();
						if (extraItem && extraItem.length > 0) {
							// paymentAmount += ceremonyFee.deposit;
							paymentAmount = this.datastoreService.totalCost;
							bookingPrice += ceremonyFee.cost;
							// if (!this.adminJourney) {
							await this.apiService.linkExtraItem(
								this.selectedLocation.id,
								this.datastoreService.selectedService.id,
								booking.id,
								extraItem,
								ceremonyFee
							);
							// }
						}
					}
					// now link other items
					for (const extraItem of this.datastoreService.serviceFees) {
						if (extraItem.questionid) {
							const question = this.datastoreService.companyQuestions.find(
								(q) => q.id == extraItem.questionid
							);
							if (question) {
								if (question.help_text) {
									const schema: any = JSON.parse(question.help_text);
									if (schema['extra-item']) {
										const extraItemId = schema['extra-item'];
										foundExtraItemIds.push(extraItemId);
										foundExtraItemCharges.push(
											extraItem.cost * parseInt(extraItem.quantity)
										);
										// if (question.id == this.datastoreService.config.journey_config.ceremonies.included_certificates_question) {
										// paymentAmount += (extraItem.cost * parseInt(extraItem.quantity));
										// bookingPrice += (extraItem.cost * parseInt(extraItem.quantity));
										// chargePrice += extraItem.cost;
										bookingPrice +=
											extraItem.cost * parseInt(extraItem.quantity);
										// bookingPrice += extraItem.cost;
										// }
										certs++;
										// Always link extra items
										// if (!this.adminJourney) {
										await this.apiService.linkExtraItem(
											this.selectedLocation.id,
											this.datastoreService.selectedService.id,
											booking.id,
											extraItemId,
											extraItem
										);
										// }
									} else {
										console.log('Missing extra item');
									}
								} else {
									console.log('Missing schema');
								}
							} else {
								console.log(`Cant find question ${extraItem.questionid}`);
								chargePrice += extraItem.cost;
								bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
								await this.apiService.linkExtraItem(
									this.selectedLocation.id,
									this.datastoreService.selectedService.id,
									booking.id,
									extraItem.item_id,
									extraItem
								);
							}
						} else {
							console.log('No question ID on extra item');
							chargePrice += extraItem.cost;
							bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
							await this.apiService.linkExtraItem(
								this.selectedLocation.id,
								this.datastoreService.selectedService.id,
								booking.id,
								extraItem.item_id,
								extraItem
							);
						}
					}
				}
			}
		} catch (err) {
			console.log(err);
		}

		if (
			!this.datastoreService.adminJourney &&
			this.datastoreService.selectedService.extra?.online_payment == 'Yes' &&
			ceremonyFee &&
			ceremonyFee.hasOwnProperty('deposit')
		) {
			try {
				console.log(`Booking price: ${bookingPrice}`);
				// now we update the price of the booking
				await this.apiService.updatePrice(
					this.selectedLocation,
					booking.id,
					purchase.id,
					`${bookingPrice * 100}`,
					'0'
				);

				localStorage.setItem('booking', JSON.stringify(booking));
				// set the resource, the date time and the location, the booking all on localstorage
				localStorage.setItem(
					'resource',
					JSON.stringify(this.selectedResourceObj)
				);
				localStorage.setItem('date', JSON.stringify(this.selectedSlot));
				localStorage.setItem('location', JSON.stringify(this.selectedLocation));
				localStorage.setItem('booking', JSON.stringify(booking));
				localStorage.setItem('service', JSON.stringify(this.selectedService));
				const extraItemId =
					this.datastoreService.selectedService.extra?.fees_extra_item_id.trim();
				let extraItem;
				const extraItemBonus = [];
				try {
					extraItem = await this.apiService.getExtraItem(
						booking.company_id,
						this.selectedService.global_id,
						extraItemId
					);
					for (let i in foundExtraItemIds) {
						res = await this.apiService.getExtraItem(
							booking.company_id,
							this.selectedService.global_id,
							foundExtraItemIds[i]
						);
						if (res) {
							res.chargePrice = foundExtraItemCharges[i];
							extraItemBonus.push(res);
						}
					}
				} catch (err) {
					console.error(err);
				}
				// const redir = await this.capitaService.invoke(
				//   this.selectedLocation,
				//   booking,
				//   purchase,
				//   this.member,
				//   this.selectedService.name,
				//   (extraItem) ? extraItem.data.gl_code : '',
				//   (this.datastoreService.totalCost * 100), // (paymentAmount * 100),
				//   false,
				//   (extraItem) ? extraItem.data.short_code : '',
				//   extraItemBonus
				// );
				// if (redir && redir["invoke_status"] === "SUCCESS") {
				//   localStorage.setItem("scp", redir["scp"]);
				//   window.location = redir["url"];
				// }
			} catch (err) {
				console.error(err);
				// this.apiService.logPaymentExtra(
				//   this.selectedLocation,
				//   this.selectedService,
				//   purchase.id,
				//   {
				//     "purchase": purchase,
				//     "invoke_error": err
				//   }
				// );
				this.basketService.deleteAllBaskets(this.selectedLocation);
				this.spinner.hide();
				this.checkoutStarted = false;
			}
		} else {
			// update booking price
			// let questionPrice = 0
			// for (const q of booking._embedded.answers) {
			//   if (q.question_id == 34666) {
			//     if (q.value > 0) {
			//       questionPrice = q.value
			//       const newPrice = (questionPrice * 100) + booking.price;
			//       await this.apiService.updatePrice(this.selectedLocation, booking.id, booking.purchase_id, newPrice, booking.paid);
			//     }
			//   }
			// }
			// if (this.datastoreService.config.hasOwnProperty('journey_config')) {
			//   if (this.datastoreService.config.journey_config.hasOwnProperty('ceremonies')) {
			//     if (this.datastoreService.config.journey_config.ceremonies.hasOwnProperty('included_certificates_question')) {
			//       const includedCerts = this.datastoreService.config.journey_config.ceremonies.included_certificates_question;
			//       if (this.datastoreService.config.journey_config.ceremonies.included_certificates_question.length > 0) {
			//         let certsToAdd = 0;
			//         for (const extraItem of this.datastoreService.serviceFees) {
			//           if (extraItem.questionid) {
			//             const question = this.datastoreService.companyQuestions.find((q) => q.id == extraItem.questionid);
			//             // Only do this for initial included certificates
			//             console.log(includedCerts);
			//             console.log('question', question);
			//             const foundItem = includedCerts.find((q:any) => q.question_id == question.id);
			//             console.log('foundItem', foundItem);
			//             if (foundItem) {
			//               if (question && question.id === foundItem.question_id) {
			//                 if (question.help_text) {
			//                   const schema: any = JSON.parse(question.help_text);
			//                   if (schema['extra-item']) {
			//                     const extraItemId = schema['extra-item'];
			//                     if (!foundExtraItemId) {
			//                       foundExtraItemId = extraItemId;
			//                     }
			//                     console.log(extraItem);
			//                     let itemQty;
			//                     if (extraItem.quantity) {
			//                       itemQty = parseInt(extraItem.quantity);
			//                       if (certsToRemoveCount > 0) {
			//                         itemQty -= certsToRemoveCount;
			//                         if (itemQty < 0) {
			//                           itemQty = 0;
			//                         }
			//                       }

			//                       if (itemQty > 0) {
			//                         console.log('options', question.options, question.options.length-1, certsToRemoveCount, question.options[(question.options.length-1) - itemQty]);
			//                         console.log(bookingPrice);
			//                         bookingPrice -= (question.options[(question.options.length-1) - itemQty].price / 100);
			//                         console.log(bookingPrice);
			//                         extraItem.quantity = certsToRemoveCount;
			//                         // certs += certsToRemoveCount;
			//                         await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItemId, extraItem, 'subtract');
			//                       }
			//                       if (itemQty === 0) {
			//                         bookingPrice -= (question.options[question.options.length-1].price / 100);
			//                       }
			//                     }
			//                     // paymentAmount += (extraItem.cost * parseInt(extraItem.quantity));
			//                     // bookingPrice += (extraItem.cost * parseInt(extraItem.quantity));

			//                   }
			//                   else {
			//                     console.log('Missing extra item');
			//                   }
			//                 }
			//                 else {
			//                   console.log('Missing schema');
			//                 }

			//               }
			//               else {
			//                 console.log(`Cant find question ${extraItem.questionid}`);
			//               }
			//             }

			//           }
			//           else {
			//             console.log('No question ID on extra item');
			//           }
			//         }
			//       }
			//     }
			//   }

			// }
			// now we update the price of the booking
			const extraItems = [];
			if (foundExtraItemIds) {
				for (const foundExtraItemId of foundExtraItemIds) {
					const extraItem = await this.apiService.getExtraItem(
						booking.company_id,
						this.datastoreService.selectedService.global_id,
						foundExtraItemId
					);
					extraItems.push(extraItem);
				}
			}
			let note = `Payment type: `;
			let payCallNote = '';
			let hasDeposit = false;
			const authToken: string = localStorage.getItem('auth_token');
			console.log('authToken', authToken);
			const extra: any =
				await this.apiService.getServiceItemExtraLinksForBooking(
					booking.company_id,
					booking.id,
					authToken,
					this.member.id
				);

			if (extra && extra.length > 0) {
				for (const item of extra) {
					if (
						item.item_id !==
						this.datastoreService.selectedService.extra?.fees_extra_item_id
					) {
						if (item.data && item.data.quantity) {
							certs = parseInt(item.data?.quantity);
						}
						break;
					}
				}
				for (const item of extra) {
					if (
						item.item_id ===
						this.datastoreService.selectedService.extra?.fees_extra_item_id
					) {
						// now we know the deposit and full fee value
						if (item.data.deposit !== item.data.cost) {
							// const ceremonyDate = moment(this.booking.datetime);
							const daysAway = moment(booking.datetime).diff(moment(), 'd');
							if (daysAway > 182) {
								note = `${note} Ceremony Fee Deposit`;
								payCallNote = `Ceremony Fee Deposit`;
								if (certs > 0) {
									note = `${note} & Certificates in Full`;
									payCallNote = `${payCallNote} & Certificates in Full`;
								}
								hasDeposit = true;
							} else {
								note = `${note} Ceremony Fee`;
								payCallNote = `Ceremony Fee`;
								if (certs > 0) {
									note = `${note} & Certificates in Full`;
									payCallNote = `${payCallNote} & Certificates in Full`;
								}
							}
						} else {
							note = `${note} Ceremony Fee`;
							payCallNote = `Ceremony Fee`;
							if (certs > 0) {
								note = `${note} & Certificates in Full`;
								payCallNote = `${payCallNote} & Certificates in Full`;
							}
						}
					}
				}
			}

			note = `${note} ${this.form.note.value}`;
			payCallNote = `${this.form.note.value}`;

			note += ` | Deposit? ${hasDeposit ? 'Yes' : 'No'}`;
			if (certs > 0 && extraItems) {
				for (const extraItem of extraItems) {
					note += `| Selected available extra: ${extraItem.item_name}`;
				}
				note += ` | Quantity: ${certs}`;
			}
			note += ` | Deposit payment date: ${moment()
				.tz('Europe/London')
				.format('dddd, MMMM Do YYYY')}`;
			note += ` | Deposit payment amount: £${parseFloat(
				this.form.amount.value
			)}`;
			note += ` | Deposit receipt number: ${this.form.reference.value}`;

			console.log(this.form);

			try {
				await this.apiService.updatePrice(
					this.selectedLocation,
					booking.id,
					booking.purchase_id,
					`${bookingPrice * 100}`,
					`0`
				);
				await this.apiService.payPurchase(
					this.selectedLocation.id,
					booking.service_id,
					booking.purchase_id,
					{
						amount: parseFloat(this.form.amount.value),
						transaction_id: `${this.form.reference.value}`,
						notify: false,
						notify_admin: false,
						payment_status: 'paid',
						notes: `${payCallNote}`,
					},
          purchase._embedded.client.id
				);
				await this.apiService.addNoteToBooking(this.selectedLocation, booking.id, note).then(async (body: any) => {
					// Loop over booking.questions and attach images for base64 answers
					for (const key in body.questions) {
						if (body.questions.hasOwnProperty(key)) {
							const question = body.questions[key];

							if (question.answer && typeof question.answer === 'string' && question.answer.startsWith('data:image/')) {
								try {
									await this.basketService.attachImageToBooking(
										body.purchase_ref,
										body.id,
										question.answer
									);
									console.log(`Attached image for question: ${question.name}`);
								} catch (error) {
									console.error(`Error attaching image for question: ${question.name}`, error);
								}
							}
						}
					}
				});
			} catch (err) {
				console.error(err);
			}

			if (this.datastoreService.clientCreated) {
				this.datastoreService.clientCreated = false;
				try {
					await this.apiService.sendWelcomeEmail(
						this.selectedLocation.id,
						this.member.id
					);
					await this.apiService.bookingTimeline(
						this.selectedLocation.id,
						booking.purchase_id,
						this.member.id,
						this.member.email
					);
				} catch (err) {
					console.error(err);
				}
			}
			// set the resource, the date time and the location, the booking all on localstorage
			localStorage.setItem(
				'resource',
				JSON.stringify(this.selectedResourceObj)
			);
			localStorage.setItem('date', JSON.stringify(this.selectedSlot));
			localStorage.setItem('location', JSON.stringify(this.selectedLocation));
			localStorage.setItem('booking', JSON.stringify(booking));
			localStorage.setItem('service', JSON.stringify(this.selectedService));
			this.router.navigate(['/confirmation']);
		}
	}

	async preCheckoutExtras() {
		try {
			if (this.datastoreService.serviceFees.length > 0) {
				// find ceremony base cost
				const noQuestionId = this.datastoreService.serviceFees.find(
					(item) => item.questionid == 'noid2'
				);
				console.log('noQuestionId', noQuestionId);
				if (noQuestionId) {
					this.ceremonyFee = noQuestionId;
					// remove the base cost from the array
					this.datastoreService.serviceFees =
						this.datastoreService.serviceFees.filter(
							(item) => item.questionid !== 'noid2'
						);
				}
			}

			// ceremonyFee = this.datastoreService.serviceFees.shift();
		} catch (err) {
			console.log(err);
		}
		console.log(
			'this.datastoreService.adminJourney',
			this.datastoreService.adminJourney,
			'this.datastoreService.selectedService.extra?.online_payment',
			this.datastoreService.selectedService.extra?.online_payment,
			'this.datastoreService.serviceFees',
			this.datastoreService.serviceFees,
			'ceremonyFee',
			this.ceremonyFee
		);
		let paymentAmount = 0;
		let bookingPrice = 0;
		let chargePrice = 0;
		let certs = 0;
		let foundExtraItemIds = [];
		let foundExtraItemCharges = [];

		let certsToRemoveCount = 0;
		if (this.adminJourney) {
			const certsToRemove = this.adminForm.controls['certificate_removal'];
			if (parseInt(certsToRemove.value) > 0) {
				console.log(`We should remove ${certsToRemove.value} certificates`);
				certsToRemoveCount = parseInt(certsToRemove.value);
			}
		}

		try {
			// link booking to extra item ONLY IF we are not an admin journey, but we always want to calculate the price.
			if (this.datastoreService.config.hasOwnProperty('journey_config')) {
				if (
					this.datastoreService.config.journey_config.hasOwnProperty(
						'ceremonies'
					)
				) {
					// if (this.datastoreService.config.journey_config.ceremonies.hasOwnProperty('fees_extra_item_id')) {
					//   const extraItem = this.datastoreService.config.journey_config.ceremonies.fees_extra_item_id.trim();
					//   await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem, ceremonyFee);
					// }
					if (this.datastoreService.selectedService.extra?.fees_extra_item_id) {
						const extraItem =
							this.datastoreService.selectedService.extra?.fees_extra_item_id.trim();
						if (extraItem && extraItem.length > 0) {
							// paymentAmount += ceremonyFee.deposit;
							paymentAmount = this.datastoreService.totalCost;
							bookingPrice += this.ceremonyFee.cost;
							console.log(
								'paymentAMount',
								paymentAmount,
								'price',
								bookingPrice
							);
							// if (!this.adminJourney) {
							// await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem, ceremonyFee);
							// }
						}
					}
					// now link other items
					for (const extraItem of this.datastoreService.serviceFees) {
						if (extraItem.questionid) {
							const question = this.datastoreService.serviceQuestionSchema[this.datastoreService.selectedSchema].schema.fields.find(
									(q) => q.field == extraItem.questionid
								);
							if (question) {
                console.log('question', question);
                if (question.hasOwnProperty('extra-item') && question['extra-item']) {
                    const extraItemId = question['extra-item'];
                    foundExtraItemIds.push(extraItemId);
                    foundExtraItemCharges.push(
                      extraItem.cost * parseInt(extraItem.quantity)
                    );
                    bookingPrice +=
                      extraItem.cost * parseInt(extraItem.quantity);
                    // bookingPrice += extraItem.cost;
                    console.log('ei bookingPrice', bookingPrice);
                    paymentAmount +=
                      extraItem.cost * parseInt(extraItem.quantity);
                    console.log('ei paymentAmount', paymentAmount);
                    // }
                    certs++;
                  }
                  else {
                    console.log('question missing extra-item', question);
                  }

							} else {
								console.log(`Cant find question ${extraItem.questionid}`);
								chargePrice += extraItem.cost;
								bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
								// await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem.item_id, extraItem);
							}
						} else {
							console.log('No question ID on extra item');
							chargePrice += extraItem.cost;
							bookingPrice += extraItem.cost * parseInt(extraItem.quantity);
							// await this.apiService.linkExtraItem(this.selectedLocation.id, this.datastoreService.selectedService.id, booking.id, extraItem.item_id, extraItem);
						}
					}
				}
			}
			return {
				paymentAmount,
				bookingPrice,
			};
		} catch (err) {
			console.log(err);
		}
	}

	formatQuestion(value) {
		// Check if the alue matches the date pattern
		const datePattern = /^\d{4}-\d{2}-\d{2}$/;
		if (datePattern.test(value)) {
			const [year, month, day] = value.split('-');
			return `${day}-${month}-${year}`; // Format as "DD-MM-YYYY"
		}

		// Check if the value is "true" or "false"
		if (value === 'true' || value === true) {
			return 'Yes';
		}
		if (value === 'false' || value === false) {
			return 'No';
		}

		// Return the value as-is for other cases
		return value;
	}

	// Scroll to the top of the page
	/**
	 * Log in as an existing JRNI record and move this journey's service item onto a
	 * basket owned by the new session. SSO rotates the JRNI session token, so the
	 * basket built at slot selection can never be checked out again and has to be
	 * rebuilt — via basket-public/service_item-public, the only route that yields a
	 * basket id that actually holds the item (see the basket-id contract in
	 * CLAUDE.md).
	 *
	 * Emits this.store once the rebuilt basket is ready. Returns the SSO response,
	 * or null having already surfaced the error and hidden the spinner.
	 */
	private async ssoExistingClient(params: any): Promise<any> {
		const token: any = await this.apiService.generateSSOToken(
			this.selectedDepartment.id,
			params.first_name,
			params.last_name,
			params.email
		);
		// api.service swallows HTTP failures and returns the error message as a STRING
		// instead of throwing, so check the shape before trusting it.
		if (!token || typeof token !== 'object' || !token.token) {
			this.abortCheckout('SSO token could not be generated', token);
			return null;
		}

		const ssoRes: any = await this.apiService.ssoLogin(
			this.selectedDepartment.id,
			token.token
		);
		if (
			!ssoRes ||
			typeof ssoRes !== 'object' ||
			!ssoRes.auth_token ||
			!ssoRes._embedded ||
			!ssoRes._embedded.members ||
			!ssoRes._embedded.members[0]
		) {
			// Where the fall-through to $post('client') used to be. An email JRNI already
			// holds must stop here, visibly — never be registered a second time.
			this.abortCheckout('SSO login failed for an existing record', ssoRes);
			return null;
		}

		// Read the item off the basket we are about to delete.
		const currentServiceItem: any = this.basketService.currentServiceItem;
		if (!currentServiceItem || !currentServiceItem.start) {
			this.abortCheckout(
				'no service item to move onto the member basket',
				currentServiceItem
			);
			return null;
		}

		// Delete the old basket with the OLD token, before the session rotates.
		await this.apiService.deleteBaskets(this.selectedLocation);
		this.datastoreService.client = ssoRes._embedded.members[0];
		localStorage.setItem('auth_token', ssoRes.auth_token);
		console.log('datastore client (from SSO)', this.datastoreService.client);

		this.apiService.createBasket(this.selectedLocation).subscribe({
			next: async (response) => {
				try {
					const newBasket = response.body;
					// The pre-basket worker checks out BY BASKET ID, so the basket we hand on
					// must have an id and must end up holding the item.
					if (!newBasket || !newBasket.id) {
						throw new Error(
							`Basket rebuild returned no id: ${JSON.stringify(newBasket)}`
						);
					}
					this.basketService.currentBasket = newBasket;
					const newServiceItem: any = await this.apiService.addServiceItem(
						this.selectedLocation,
						newBasket,
						currentServiceItem.start,
						{ id: currentServiceItem.service_id },
						[],
						currentServiceItem.duration,
						this.selectedResourceObj
					);
					// api.service returns the error message as a STRING on failure; an item with
					// no id means the rebuilt basket is EMPTY, which is how a customer gets
					// charged for a booking nobody makes.
					if (
						!newServiceItem ||
						typeof newServiceItem !== 'object' ||
						!newServiceItem.id
					) {
						throw new Error(
							`Service item rebuild failed: ${JSON.stringify(newServiceItem)}`
						);
					}
					this.basketService.currentServiceItem = newServiceItem;
					console.log(
						`Replaced service item as we are now logged in as a member`,
						newServiceItem
					);
					this.store.next(true); // update behavior subject
				} catch (err) {
					this.abortCheckout('basket rebuild after SSO failed', err);
				}
			},
			error: (err) => {
				this.abortCheckout('basket rebuild after SSO failed', err);
			},
		});

		return ssoRes;
	}

	/**
	 * One exit for every failure between spinner.show() and the gateway redirect.
	 * A catch that only console.error()s leaves the spinner up and the Continue
	 * button disabled, with nothing the customer can act on — that is how a handled
	 * JRNI 401 became a silent hang.
	 */
	private abortCheckout(reason: string, detail?: any) {
		console.error(`Aborting checkout — ${reason}`, detail);
		this.clearCheckoutWatchdog();
		this.checkoutStarted = false;
		this.spinner.hide();
		this.alertService.error(
			this.translateService.instant('COMMON.LOAD_ISSUE')
		);
		this.scrollToTop();
	}

	// Covers the one case the try/catches cannot: an async path that neither emits
	// nor throws, so nothing ever hides the spinner.
	private startCheckoutWatchdog(timeoutMs = 60000) {
		this.clearCheckoutWatchdog();
		this.checkoutWatchdog = setTimeout(() => {
			this.checkoutWatchdog = null;
			if (this.checkoutStarted) {
				this.abortCheckout('timed out before reaching the payment gateway');
			}
		}, timeoutMs);
	}

	private clearCheckoutWatchdog() {
		if (this.checkoutWatchdog) {
			clearTimeout(this.checkoutWatchdog);
			this.checkoutWatchdog = null;
		}
	}

	ngOnDestroy() {
		this.clearCheckoutWatchdog();
	}

	scrollToTop() {
		const scrollToOptions = { top: 0, left: 0, behavior: 'instant' };
		window.scrollTo(scrollToOptions as unknown as ScrollToOptions);
	}
}
